import { apiSlice } from "../api/apiSlice";

export const masterySlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMastery: builder.query({
      query: () => `/my/progress`,
      providesTags: (result, error, arg) => [{ type: "Mastery" }],
    }),
  }),
});

export const { useGetMasteryQuery } = masterySlice;
